import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h4 className="font-heading text-lg font-bold text-background-50 mb-4">羁绊创作工坊</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              专注姐妹情感羁绊创作，为写作者与角色扮演爱好者提供深度指南与灵感。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">创作分类</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/character-relationship" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">人物关系构建</Link></li>
              <li><Link to="/category/emotional-tension" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">情感张力设计</Link></li>
              <li><Link to="/category/plot-conflict" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">剧情冲突技巧</Link></li>
              <li><Link to="/category/roleplay-guide" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">角色扮演指南</Link></li>
              <li><Link to="/category/creative-writing" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">小说写作技法</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">关于我们</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">联系方式</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">品牌声誉</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">关注我们</h4>
            <p className="text-sm text-background-400 mb-4 leading-relaxed">
              订阅创作通讯，获取最新文章推送与独家创作资源。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-accent-600 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-accent-600 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-accent-600 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="邮箱" rel="nofollow">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {currentYear} 羁绊创作工坊. 保留所有权利.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">隐私政策</a>
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}